import { uploadInventoryImage, updateGallery } from "../../../checkin/request/file-upload-requests";
import { getErrorMessageForNonStandardAndStandardResponse } from "../../../../util/NetworkErrorUtil";
import { createTimestampedFileName } from "../../../../util/FileUtils";
import { CheckOutAsset } from "../data";

import {SnackbarShowMessage} from "../../../../context/snackbar-context";

const updateGalleryTable = async (allGalleryFiles: any, checkout: CheckOutAsset, snackbarShowMessage: SnackbarShowMessage) => {
    return updateGallery(checkout.id, allGalleryFiles)
        .catch(error => snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error'));
}

const uploadGallery = (uploadedFiles: any, allGalleryFiles: any, checkout: CheckOutAsset, snackbarShowMessage: SnackbarShowMessage) => {

    if (!uploadedFiles || uploadedFiles.length === 0) {
        updateGalleryTable(allGalleryFiles, checkout, snackbarShowMessage);
        return;
    }

    const selectFile = uploadedFiles.shift();

    if (selectFile && selectFile.name) {

    const fileName = createTimestampedFileName(selectFile.name);
    uploadInventoryImage(checkout.id, selectFile.dataURL, fileName, selectFile.type)
        .then((data) => {
            allGalleryFiles.push(data);
            uploadGallery(uploadedFiles, allGalleryFiles, checkout, snackbarShowMessage);
        })
        .catch((error) => {
            snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error')
        });
    }
}

const saveGallery = (checkout: CheckOutAsset, imageDropZone: any, snackbarShowMessage: SnackbarShowMessage) => {

    const uploadedGalleryFiles: any[] = [];
    const allGalleryFiles: any[] = [];

    const {files} = imageDropZone;

    if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            if (file && file.type !== 'fake') {
                //new file
                uploadedGalleryFiles.push(file);
            } else {
                allGalleryFiles.push(file.name);
            }
        }
    }
    uploadGallery(uploadedGalleryFiles, allGalleryFiles, checkout, snackbarShowMessage);
};

export default saveGallery;
